"use client";

import React from "react";

import * as Icon from "@phosphor-icons/react/dist/ssr";
import { ProductType } from "../../type/ProductType";
import { useToast } from "../../context/ToastContext";
import { stripHtml, shareProductPage, getProductPageUrl, getProductShareImageUrl } from "../../utils/shareProduct";

interface Props {
  data: Array<ProductType>;
  productPage: string | null;
  productId: string | number | null;
}

const BreadcrumbProduct: React.FC<Props> = ({
  data,
  productPage: _productPage,
  productId,
}) => {
  const { showToast } = useToast();
  const productMain = data?.find(
    (product) => Number(product.id) === Number(productId)
  ) as ProductType | undefined;

  const handleShare = async () => {
    if (!productMain?.id) return;
    const url = getProductPageUrl(productMain.id);
    const plain = stripHtml(String(productMain.description || ""));
    const imageUrl = getProductShareImageUrl(productMain);
    await shareProductPage({
      title: String(productMain.name || ""),
      descriptionPlain: plain,
      url,
      imageUrl,
      onCopySuccess: () =>
        showToast("Lien copié dans le presse-papiers", "success"),
    });
  };

  return (
    <>
      <div className="breadcrumb-product">
        <div className="main py-4 sm:py-5 bg-gradient-to-r from-surface to-white border-y border-line/60">
          <div className="container">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-x-4 sm:gap-y-0">
              <div className="left inline-flex max-w-full min-w-0 flex-1 items-center gap-2 rounded-xl border border-line/80 bg-white/90 px-3 py-2 shadow-sm sm:max-w-[min(100%,42rem)]">
                <Icon.House size={15} weight="duotone" className="text-pink shrink-0" />
                <a
                  href="/"
                  className="caption1 text-secondary2 hover:text-pink transition-colors shrink-0"
                >
                  Accueil
                </a>
                <Icon.CaretRight size={12} className="text-secondary2/70 shrink-0" />
                <span className="caption1 text-secondary2 shrink-0">Produit</span>
                <Icon.CaretRight size={12} className="text-secondary2/70 shrink-0" />
                <span className="caption1 font-semibold text-pink truncate capitalize">
                  {productMain?.name}
                </span>
              </div>

              {productMain?.id ? (
                <div className="inline-flex max-w-full shrink-0 flex-nowrap items-center justify-end gap-2 self-end sm:gap-3 sm:self-center">
                  <p className="max-w-[min(100%,12.5rem)] text-[11px] font-medium leading-snug text-pink sm:max-w-[20rem] sm:text-sm sm:leading-snug">
                    Partagez ce produit avec vos proches
                  </p>
                  <button
                    type="button"
                    className="add-share-btn inline-flex h-9 shrink-0 items-center justify-center gap-1.5 rounded-xl border border-pink/25 bg-pink px-3 text-white shadow-[0_4px_14px_-4px_rgba(255,67,112,0.45)] transition duration-300 hover:brightness-110 focus-visible:outline focus-visible:ring-2 focus-visible:ring-pink/35 active:scale-[0.98] sm:h-10 sm:gap-2 sm:px-4"
                    aria-label="Partager ce produit"
                    onClick={handleShare}
                  >
                    <Icon.ShareNetwork size={20} weight="duotone" className="shrink-0 text-white" />
                    <span className="caption1 font-semibold tracking-tight">Partager</span>
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BreadcrumbProduct;
